import { Break, breakPoints } from '../index.js'
import { useCurrentBreakPoint } from './use-current-breakpoint.js'

export interface UseResponsivePropsProps<PropsType> {
    responsive: ResponsiveObject<PropsType>[]
}

export interface ResponsiveObject<PropsType> {
    /**
     * BreakPoint from where props should be applied.
     */
    breakPoint: Break
    /**
     * Props that should be applied on breakPoint
     */
    props: Partial<PropsType>
}

export function useResponsiveProps<PropsType>(props: UseResponsivePropsProps<PropsType>): Partial<PropsType> {
    const { responsive } = props

    const responsiveBreakPoints = responsive.map((resp) => resp.breakPoint)
    const currentBreakPoint = useCurrentBreakPoint()

    const getActiveBreakPoints = (bp: Break, responsiveBP: Break[]): Break[] => {
        const sortedResponsiveBreakPoints = responsiveBP.sort((x, y) => breakPoints[x] - breakPoints[y])

        return sortedResponsiveBreakPoints.filter((breakPoint) => {
            return breakPoints[breakPoint] <= breakPoints[bp]
        })
    }

    const getResponsiveProps = (breakPoint: Break) => {
        const responsiveObject = responsive.find((resp) => resp.breakPoint === breakPoint)

        /* istanbul ignore else */
        if (responsiveObject) {
            return responsiveObject.props
        }
    }

    if (!currentBreakPoint) {
        return {}
    }

    const activeBreakPoints = getActiveBreakPoints(currentBreakPoint, responsiveBreakPoints)

    return activeBreakPoints.reduce((acc, breakPoint) => ({ ...acc, ...getResponsiveProps(breakPoint) }), {})
}
